/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.conglomerateMemberships

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.conglomerateMemberships.internal.ConglomerateMembershipsUseCase
import features.conglomerateMemberships.internal.ConglomerateMembershipsUseCase.Params
import features.conglomerateMemberships.models.Businesses


typealias ConglomerateMembershipsState = CFlow<ConglomerateMembershipsUseCaseResult?>

typealias ConglomerateMembershipsUseCaseResult = Result<Businesses>

fun ConglomerateMembershipsUseCaseResult.serializeConglomerateMembershipsApiResult(): SerializedResult<String> {
    return this.toJsonResult<Businesses>()
}

/**
 * Serializes [ConglomerateMembershipsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun ConglomerateMembershipsState.serializeConglomerateMembershipsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<Businesses>()
    }.asCFlow()
}

/**
 * Get the conglomerate children of a business [Api] class
 */
class ConglomerateMembershipsApi : Api() {

    val conglomerateMembershipsState: ConglomerateMembershipsState
        get() = _conglomerateMembershipsState.asCFlow()

    companion object {
        private val _conglomerateMembershipsState: MutableStateFlow<ConglomerateMembershipsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val conglomerateMembershipsUseCase = ConglomerateMembershipsUseCase()

    /**
     * Get the conglomerate children of a business
     */
    suspend fun getConglomerateMemberships(
        overrideHeaders: Map<String, String>? = null,

    ): Result<Businesses> {
        /* set state to Loading as soon as function is called */
        _conglomerateMembershipsState.value = Loading()
        val result = this.conglomerateMembershipsUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _conglomerateMembershipsState.value = result
            return@conglomerateMembershipsUseCase result
        }
        return result
    }

}
